import { ReactNode } from 'react';
import styles from './index.module.sass'; 

export function SpecItem({ label, value }: { label: string; value: string | ReactNode }) {
    return (
      <div className={styles.specItem}>
        <span className={styles.label}>{label}</span>
        <span className={styles.value}>{value}</span>
      </div>
    );
  }